<template>
    <div class="" v-if="task">
        <p class="q-display-1" v-if="editMode">Edycja "{{task && task.label}}"</p>
        <p class="q-display-1" v-else>Definiowanie nowego zadania</p>



        <div class="task-wrapper"
             @dragover.prevent="() => {}"
             @drop="e => addTaskletToTask(e)">

            <div>
                <optional-task-component
                    :inEdit="true"
                    :inline="true"
                    :model="task"/>

                <div class="secondary-color-chooser inline"
                     :style="style"
                     @dragover.prevent="() => {}"
                     @dragleave="() => {}"
                     @dragenter="() => {}"
                     @drop="dropSecondaryBackground"
                    >

                    <q-color placeholder="Kolor tła" format-model="hex" v-model="task.secondaryBackgroundColor"/>
                </div>
            </div>

            <draggable :list="task.order" style="display: inline;" v-if="task">
                <q-card :inline="true" class="q-ma-md" v-for="(taskletId, index) in task.order" :key="index">
                    {{secondaryBackgroundColor}}
                    <generic-viewer class="q-ma-md"
                                    :draggable="true"
                                    :inline="true"
                                    v-if="allParts[taskletId] "
                                    :articlePart="allParts[taskletId]"
                                    :surveyQuestion="allParts[taskletId]"
                                    :backgroundUrl="secondaryBackgroundUrl"
                                    :backgroundColor="secondaryBackgroundColor"
                    />
                    <div class="text-right">
                        <a href="#" @click.prevent="removePartFromOrder(taskletId, task)">Usuń</a>
                    </div>
                </q-card>
            </draggable>

        </div>


        <fixed-buttons>
            <q-btn
                flat
                style="font-size: 1.5rem" dense
                icon="save"
                class="q-pa-sm"
                color="primary"
                @click="save">
                <q-tooltip anchor="top left">
                    Zapisz
                </q-tooltip>
            </q-btn>
        </fixed-buttons>
    </div>
</template>

<script>
    import QInput from 'quasar-framework/src/components/input/QInput'
    import QEditor from 'quasar-framework/src/components/editor/QEditor'
    import QTimeline from 'quasar-framework/src/components/timeline/QTimeline'
    import QTimelineEntry from 'quasar-framework/src/components/timeline/QTimelineEntry'
    import QIcon from 'quasar-framework/src/components/icon/QIcon'
    import QTooltip from 'quasar-framework/src/components/tooltip/QTooltip'
    import QBtn from 'quasar-framework/src/components/btn/QBtn'
    import FixedButtons from './FixedButtons'
    import OptionalTaskComponent from './OptionalTaskComponent'
    import draggable from 'vuedraggable'
    import GenericViewer from './pole/viewers/GenericViewer'
    import QColor from 'quasar-framework/src/components/color/QColor'

    export default {
        name: 'TaskEditor',
        components: {
            QColor,
            GenericViewer,
            OptionalTaskComponent,
            FixedButtons,
            draggable,
            QBtn,
            QTooltip, QIcon, QTimelineEntry, QTimeline, QEditor, QInput,
        },
        data () {
            return {
                newTask: {
                    optionalTaskId: this.$uuid(),
                    label: 'Nowe zadanie',
                    category: '',
                    description: '',
                    hasActivity: false,
                    group: 'junior',
                    thumbUrl: '',
                    movieUrl: '',
                    audioUrl: '',
                    backgroundUrl: undefined,
                    secondaryBackgroundUrl: undefined,
                    backgroundColor: undefined,
                    secondaryBackgroundColor: undefined,
                    minStep: 0,
                    order: [],
                    tasklets: [],
                    isNew: true
                }
            }
        },
        mounted () {
            if (this.editMode) {
                this.$store.dispatch('fetchTask', this.$route.params.optionalTaskId)
            }
            // this.fetch()
            this.$store.commit('showRightMenu', true)
        },
        destroyed () {
            this.$store.commit('showRightMenu', false)
        },
        computed: {
            editMode () {
                return this.$route.params.optionalTaskId
            },
            task () {
                if (this.editMode) {
                    return this.$store.state.tasks.find(a => a.optionalTaskId === this.$route.params.optionalTaskId)
                }

                return this.newTask
            },
            allParts () {
                if (!this.task) {
                    return {}
                }

                const resultMap = {}

                this.task.tasklets.forEach(part => {
                    if (part.taskletType === 'article') {
                        const article = this.$store.getters.article.find(a => a.articleId === part.taskletId)
                        if (!article) {
                            this.$store.dispatch('fetchArticle', part.taskletId)
                        } else {
                            article.parts.forEach(part => {
                                resultMap[part.articlePartId] = part
                            })
                        }
                    } else if (part.taskletType === 'survey') {
                        const survey = this.$store.state.survey.find(a => a.surveyId === part.taskletId)
                        if (!survey) {
                            this.$store.dispatch('fetch', {
                                what: 'survey',
                                id: part.taskletId
                            })
                        } else {
                            survey.questions.forEach(q => {
                                resultMap[q.surveyQuestionId] = q
                            })
                        }
                    }
                })

                return resultMap
            },
            secondaryBackgroundUrl () {
                return this.task && (this.task.secondaryBackgroundUrl || this.task.backgroundUrl)
            },
            secondaryBackgroundColor () {
                return this.task && (this.task.secondaryBackgroundColor || this.task.backgroundColor)
            },
            style () {
                let value = ''

                if (this.secondaryBackgroundUrl || this.secondaryBackgroundColor) {
                    // from props - higher priority than local model model values
                    if (this.secondaryBackgroundUrl) {
                        value += `background: url(${this.$store.state.MEDIA_PREFIX_FOR_IMG + this.secondaryBackgroundUrl}); background-size: cover; `
                    }

                    if (this.secondaryBackgroundColor) {
                        value += `background-color: ${this.secondaryBackgroundColor}; `
                    }
                } else {
                    if (this.task) {
                        if (this.task.backgroundUrl) {
                            value += `background: url(${this.$store.state.MEDIA_PREFIX_FOR_IMG + this.task.backgroundUrl}); background-size: cover; `
                        }

                        if (this.task.backgroundColor) {
                            value += `background-color: ${this.task.backgroundColor}; `
                        }
                    }
                }


                return value

            }

        },
        methods: {
            save () {
                if (this.task) {
                    var task = {
                        ...this.task,
                        extension: this.task.extension || {},
                        useMetrologies: false,
                        hasActivity: false,
                        badges: this.task.badges || []
                    }

                    if (task.isNew) {
                        delete task.isNew

                        this.$store.dispatch('create', {
                            what: 'optionalTask',
                            item: task,
                            id: task.optionalTaskId
                        }).then(() => {
                            this.$router.push({
                                name: 'task-edit',
                                params: {
                                    optionalTaskId: this.task.optionalTaskId
                                }
                            })
                        }).catch(() => { })
                    } else {
                        this.$store.dispatch('update', {
                            what: 'optionalTask',
                            item: task,
                            id: task.optionalTaskId
                        })
                    }
                }
            },
            addTaskletToTask (e) {
                let tasklet;
                const task = this.task

                try {
                    tasklet = JSON.parse(e.dataTransfer.getData('text'))

                    if (tasklet.type === 'article' || tasklet.type === 'survey') {
                        this.$emit('dropped', tasklet)
                    } else {
                        tasklet = undefined
                    }
                    // inline
                } catch (ee) {
                    // ...
                }

                if (! tasklet) {
                    return
                }

                if (!task.tasklets) {
                    this.$set(task, 'tasklets', [])
                }

                if (tasklet.type === 'article') {
                    const article = tasklet

                    const exists = task.tasklets.filter(t => t.taskletId === article.articleId).length > 0

                    if (!exists) {
                        task.tasklets.push({
                            taskletId: article.articleId,
                            parentId: task.optionalTaskId,
                            taskletType: 'article',
                            // backgroundUrl: ''
                        })
                    }

                    task.order = [...task.order, ...article.parts.map(p => p.articlePartId)]
                } else if (tasklet.type === 'survey') {
                    const survey = tasklet

                    const exists = task.tasklets.filter(t => t.taskletId === survey.surveyId).length > 0

                    if (!exists) {
                        task.tasklets.push({
                            taskletId: survey.surveyId,
                            parentId: task.optionalTaskId,
                            taskletType: 'survey',
                            // backgroundUrl: ''
                        })
                    }

                    task.order = [...task.order, ...survey.questions.map(q => q.surveyQuestionId)]

                }
            },
            dropSecondaryBackground (e) {
                try {
                    this.$set(this.task, 'secondaryBackgroundUrl', JSON.parse(e.dataTransfer.getData('text')).urlPath)
                } catch (ee) {
                    // ...
                }
            },
            removePartFromOrder (part, task) {
                task.order = task.order.filter(t => t !== part)

                const article = task.tasklets.filter(t => t.taskletType === 'article') // only article tasklets
                    .map(t => this.$store.getters.article.find(a => a.articleId === t.taskletId)) // get full article models
                    .find(a => (a.parts || []).map(p => p.articlePartId).indexOf(part) !== -1) // get models that have our part

                if (article) {
                    // this means we've just removed part from article
                    // let's see if there's any part of this article in 'order'
                    // if not - we'll remove this article from tasklets too
                    const common = article.parts.map(p => p.articlePartId).filter(p => task.order.includes(p))
                    if (common.length === 0) {
                        task.tasklets = task.tasklets.filter(t => t.taskletId !== article.articleId)
                    }
                }

                const survey = task.tasklets.filter(t => t.taskletType === 'survey') // only survey tasklets
                    .map(t => this.$store.getters.survey.find(s => s.surveyId === t.taskletId)) // get full survey models
                    .find(s => (s.questions || []).map(q => q.surveyQuestionId).indexOf(part) !== -1) // get models that have our question

                if (survey) {
                    // this means we've just removed part from survey
                    // let's see if there's any part of this survey in 'order'
                    // if not - we'll remove this survey from tasklets too
                    const common = survey.questions.map(q => q.surveyQuestionId).filter(q => task.order.includes(q))
                    if (common.length === 0) {
                        task.tasklets = task.tasklets.filter(t => t.taskletId !== survey.surveyId)

                    }
                }
            },

        },
    }
</script>

<style scoped>
    .secondary-color-chooser {
        border: 1px solid black;
        width: 150px;
        height: 200px;
        border-radius: 20px;
        display: inline-block;
    }
</style>